var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"orgTree",staticClass:"org-chart-wrapper bgTable col-12",on:{"click":_vm.onClickTree}})
}
var staticRenderFns = []

export { render, staticRenderFns }